export enum GenderIds {
    MALE = 101,
    FEMALE = 102,
}